import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AtividadeDetalhe } from '../models/atividade/atividade-detalhe';
import { AtividadeAditamento } from '../models/atividade/atividade-aditamento';
 
@Injectable({
  providedIn: 'root'
})
export class AtividadeAditamentoService {

  private environmentUrl: string = '';

  constructor(
    private httpClient: HttpClient
  ) {
    this.environmentUrl = environment.ApiAtv;
  }

  listarAditamentos(idAtividade: number): Observable<AtividadeAditamento[]> {
    const url = this.environmentUrl + 'v1/Atividade/GetAtividadesAditamentos/' + idAtividade;
    return this.httpClient.get<AtividadeAditamento[]>(url);
  }
}

